












































































































































































































































































import { CustomerDashboardResponse, LatLng, MemberProfile, ServiceRequestStatistics } from '@/types/response';
import { Component, Vue } from 'vue-property-decorator';
import GoogleMap from '../components/GoogleMap.vue';
import { Bar, Pie } from 'vue-chartjs';
// tslint:disable-next-line:no-var-requires
import Chart from 'chart.js';
import { MedTransGoConstants } from '@/util/constants';
import { ApiRequest, GetRequestStatistics } from '@/types/request';
import { ObjectFactory } from '@/config/objectFactory';
import { DateUtils } from '@/util/dateUtils';
import { OrgLocation } from '@/types/entity';
import { CommonUtils } from '@/util/commonUtils';
import { max } from 'moment-timezone';

@Component({
    components: {
        GoogleMap,
    },
})
export default class Dashboard extends Vue {
    private TrnasportationVehicleTypeBarChartInstance: Chart | null = null;
    private InterpretationModeBarChartInstance: Chart | null = null;
    private InterpretationModePieChartInstance: Chart | null = null;
    private TrnasportationVehicleTypePieChartInstance: Chart | null = null;
    private TrnasportationRequestTimingShedulePieChartInstance: Chart | null = null;
    private TrnasportationRequestTimingASAPPieChartInstance: Chart | null = null;
    private TrnasportationTripTypeRoundOrOneWayPieChartInstance: Chart | null = null;
    private TrnasportationPickAndAppointmentPieChartInstance: Chart | null = null;
    private InterpretationRequestTimingShedulePieChartInstance: Chart | null = null;
    private InterpretationRequestTimingASAPPieChartInstance: Chart | null = null;
    private InterpretationLanguagesBarChartInstance: Chart | null = null;
    private startDate = null;
    private endDate = null;
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private selectedBillingLocations = [];
    private reportData: CustomerDashboardResponse = {
        interpretation: {
            interpretationMode: {
                inPerson: 0,
                phone: 0,
                video: 0,
            },
            timing: {
                immediate: 0,
                notImmediate: 0,
                preScheduled: 0,
                sameDay: 0,
            },
            topLanguages: null as any,
        },
        transportation: {
            timing: {
                asap: 0,
                noAsap: 0,
                preScheduled: 0,
                sameDay: 0,
            },
            tripType: {
                appointmentTime: 0,
                oneWayTrip: 0,
                pickupTime: 0,
                roundTrip: 0,
            },
            vehicleType: {
                bls: 0,
                sedan: 0,
                stretcher: 0,
                wheelChair: 0,
            },
        },
    };
    private orgLocations: OrgLocation[] = [];

    private async mounted() {
        await this.getOrganizationLocations();
        await this.getReportData();
    }

    private renderDashboardChartData() {
        this.renderTrnasportationVehicleTypeBarChart();
        this.renderTrnasportationVehicleTypePieChart();
        this.renderInterpretationModeBarChart();
        this.renderInterpretationModePieChart();
        this.renderTrnasportationRequestTimingShedulePieChart();
        this.renderTrnasportationRequestTimingASAPPieChart();
        this.renderTrnasportationTripTypeRoundOrOneWayPieChart();
        this.renderTrnasportationPickAndAppointmentPieChart();
        this.renderInterpretationRequestTimingShedulePieChart();
        this.renderInterpretationRequestTimingASAPPieChart();
        this.renderInterpretationLanguagesBarChart();
    }

    private getChartData(label: string, labels: string[], data: number[], backgroundColors: string[]) {
        return {
            labels,
            datasets: [
                {
                    label,
                    data,
                    backgroundColor: backgroundColors,
                    borderColor: backgroundColors,
                    borderWidth: 1,
                },
            ],
        };
    }

    private getTrnasportationVehicleTypeChartData() {
        const vehicleTypeResponse = this.reportData.transportation.vehicleType;
        return this.getChartData(
            'Vehicle Type',
            ['Sedan', 'Wheelchair', 'Stretcher', 'BLS'],
            [vehicleTypeResponse.sedan, vehicleTypeResponse.wheelChair, vehicleTypeResponse.stretcher,
            vehicleTypeResponse.bls],
            ['#263FA9', '#26859e', '#39A896', '#50d0a8'],
        );
    }

    private getInterpretationModeChartData() {
        const interpretationMode = this.reportData.interpretation.interpretationMode;
        return this.getChartData(
            'Interpretation Mode',
            ['In-Person', 'Video', 'Phone'],
            [interpretationMode.inPerson, interpretationMode.video, interpretationMode.phone],
            ['#263FA9', '#26859e', '#39A896', '#50d0a8'],
        );
    }

    private getTransportationRequestTimingScheduleChartData() {
        const transportationTime = this.reportData.transportation.timing;
        return this.getChartData(
            'Request Timing',
            ['Same-Day', 'Pre-Scheduled'],
            [transportationTime.sameDay, transportationTime.preScheduled],
            ['#263FA9', '#39A896'],
        );
    }

    private getTransportationRequestTimingASAPChartData() {
        const transportationAsap = this.reportData.transportation.timing;
        return this.getChartData(
            'Request Timing',
            ['ASAP\n\n\n\n\n\n\n\n\n\n\n\n\n\n', 'Non-ASAP'],
            [transportationAsap.asap, transportationAsap.noAsap],
            ['#263FA9', '#39A896'],
        );
    }

    private getTransportationTripTypeRoundOrOneWayChartData() {
        const transportationTripType = this.reportData.transportation.tripType;
        return this.getChartData(
            'Trip Type',
            ['Round Trip\n\n\n\n\n\n\n\n\n\n', 'One-Way Trip'],
            [transportationTripType.roundTrip, transportationTripType.oneWayTrip],
            ['#263FA9', '#39A896'],
        );
    }

    private getTransportationTripTypePickOrAppointmentChartData() {
        const transportationType = this.reportData.transportation.tripType;
        return this.getChartData(
            'Trip Type',
            ['Pick-Up Time', 'Appointment Time'],
            [transportationType.pickupTime, transportationType.appointmentTime],
            ['#263FA9', '#39A896'],
        );
    }

    private getInterpretationRequestTimingScheduleChartData() {
        const interpretationTiming = this.reportData.interpretation.timing;
        return this.getChartData(
            'Request Timing',
            ['Same-Day', 'Pre-Scheduled'],
            [interpretationTiming.sameDay, interpretationTiming.preScheduled],
            ['#263FA9', '#39A896'],
        );
    }

    private getInterpretationRequestTimingASAPChartData() {
        const interpretationType = this.reportData.interpretation.timing;
        return this.getChartData(
            'Request Timing',
            ['Immediate', 'Non-Immediate'],
            [interpretationType.immediate, interpretationType.notImmediate],
            ['#263FA9', '#39A896'],
        );
    }

    private getInterpretationLanguagesChartData() {
        return this.getChartData(
            'Request Count',
            this.reportData.interpretation.topLanguages.map((item) => item.language),
            this.reportData.interpretation.topLanguages.map((item) => item.count),
            ['#263FA9', '#26859e', '#39A896', '#50d0a8', '#0a167f'],
        );
    }

    private generateCustomLegend(
        legendRef: HTMLElement | null,
        chartInstance: Chart | null,
        labels: string[],
        colors: string[],
        descriptions: string[],
        legendClass: string,
    ) {
        if (!legendRef) {
            return;
        }

        // Check if the ref is for customLegendvehicleType
        const isVehicleTypeLegend = legendRef === this.$refs.customLegendvehicleType ||
            legendRef === this.$refs.customLegendModeOfInterpretation;
        const flexStyle = isVehicleTypeLegend ? 'display: flex; flex-wrap: wrap;' : '';
        const marginStyle = isVehicleTypeLegend ? 'margin-left: 5px; margin-right: 5px' : '';

        let legendHTML = `<ul style="list-style:none; padding:0; margin:0; ${flexStyle}">`;
        labels.forEach((label, i) => {
            const spanWidth = descriptions[i] ? '0px' : '0px';
            legendHTML += `
        <li class="${legendClass}" data-index="${i}"
            style="display: flex; align-items: center; margin-bottom: 8px; ${marginStyle}">
            <span class="legend-color"
                style="width: ${spanWidth}; min-width: 12px; height: 12px; display: inline-block; background-color: ${colors[i]};
                margin-right: 8px; align-self: baseline; margin-top: 4px">
            </span>
            <div>
                <strong class="legend-label">${label}</strong>
                <p style="font-size: 9px; margin-bottom: 0">${descriptions[i]}</p>
            </div>
        </li>
    `;
        });
        legendHTML += '</ul>';

        legendRef.innerHTML = legendHTML;
    }



    private renderTrnasportationVehicleTypeBarChart() {
        this.$nextTick(() => {
            const ctx = (this.$refs.vehicleTypeBarChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.TrnasportationVehicleTypeBarChartInstance) {
                this.TrnasportationVehicleTypeBarChartInstance.destroy();
            }
            this.TrnasportationVehicleTypeBarChartInstance = new Chart(ctx, {
                type: 'horizontalBar',
                data: this.getTrnasportationVehicleTypeChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            stacked: true,
                            gridLines: {
                                display: false,
                                drawBorder: false,
                            },
                            ticks: {
                                beginAtZero: true,
                                precision: 0,
                                stepSize: 1,
                                suggestedMax: this.calculateSuggestedMaxTransportation(),
                                callback: (value) => {
                                    return Number.isInteger(value) ? value : null;
                                },
                            },
                        }],
                        yAxes: [{
                            stacked: true,
                        }],
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                        onClick: (e) => {
                            e.stopPropagation();
                        },
                    },
                    animation: {
                        onComplete() {
                            const chartInstance = this as any;
                            const ctxx = chartInstance.chart.ctx;
                            ctxx.textAlign = 'left';
                            ctxx.textBaseline = 'middle';
                            ctxx.fillStyle = '#000';

                            chartInstance.data.datasets.forEach((dataset: any, i: number) => {
                                const meta = chartInstance.getDatasetMeta(i);
                                meta.data.forEach((bar: any, index: number) => {
                                    const data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x + 10, bar._model.y);
                                });
                            });
                        },
                    },
                },
            });
        });
    }
    private calculateSuggestedMaxTransportation(): number {
        const maxValue = Math.max(...this.getTrnasportationVehicleTypeChartData().datasets[0].data);
        return maxValue < 10 ? maxValue + 2 : Math.ceil(maxValue * 1.2);
    }

    private renderTrnasportationVehicleTypePieChart() {
        this.$nextTick(() => {

            const chartData = this.getTrnasportationVehicleTypeChartData();
            const hasData = chartData.datasets.some((dataset) => dataset.data.some((value) => value > 0));

            const ctx = (this.$refs.vehicleTypePieChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.TrnasportationVehicleTypePieChartInstance) {
                this.TrnasportationVehicleTypePieChartInstance.destroy();
            }

            if (!hasData) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = '14px Arial';
                ctx.fillStyle = '#999';
                ctx.textAlign = 'center';
                ctx.fillText('', ctx.canvas.width / 2, ctx.canvas.height / 2);
                return;
            }

            this.TrnasportationVehicleTypePieChartInstance = new Chart(ctx, {
                type: 'pie',
                data: this.getTrnasportationVehicleTypeChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                        position: 'top',
                        align: 'start',
                        fullWidth: true,
                        textDirection: 'ltr',
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                        onClick: (e) => {
                            e.stopPropagation();
                        },
                    },
                },
            });
            this.generateCustomLegendVehicaleType();
        });
    }
    private generateCustomLegendVehicaleType() {
        this.generateCustomLegend(
            this.$refs.customLegendvehicleType as HTMLElement,
            this.TrnasportationVehicleTypePieChartInstance,
            ['Sedan', 'Wheelchair', 'Stretcher', 'BLS'],
            ['#263FA9', '#26859e', '#39A896', '#50d0a8'],
            ['', '', '', ''],
            'legend-item-vehicleType',
        );
    }

    private renderInterpretationModeBarChart() {
        this.$nextTick(() => {
            const ctx = (this.$refs.modeOfInterpretationBarChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.InterpretationModeBarChartInstance) {
                this.InterpretationModeBarChartInstance.destroy();
            }
            this.InterpretationModeBarChartInstance = new Chart(ctx, {
                type: 'horizontalBar',
                data: this.getInterpretationModeChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            stacked: true,
                            gridLines: {
                                display: false,
                                drawBorder: false,
                            },
                            ticks: {
                                beginAtZero: true,
                                precision: 0,
                                stepSize: 1,
                                suggestedMax: this.calculateSuggestedMaxInterpretation(),
                                callback: (value) => {
                                    return Number.isInteger(value) ? value : null;
                                },
                            },
                        }],
                        yAxes: [{
                            stacked: true,
                        }],
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                        onClick: (e) => {
                            e.stopPropagation();
                        },
                    },
                    animation: {
                        onComplete() {
                            const chartInstance = this as any;
                            const ctxx = chartInstance.chart.ctx;
                            ctxx.textAlign = 'left';
                            ctxx.textBaseline = 'middle';
                            ctxx.fillStyle = '#000';

                            chartInstance.data.datasets.forEach((dataset: any, i: number) => {
                                const meta = chartInstance.getDatasetMeta(i);
                                meta.data.forEach((bar: any, index: number) => {
                                    const data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x + 10, bar._model.y);
                                });
                            });
                        },
                    },
                },
            });
        });
    }
    private calculateSuggestedMaxInterpretation(): number {
        const maxValue = Math.max(...this.getInterpretationModeChartData().datasets[0].data);
        return maxValue < 10 ? maxValue + 2 : Math.ceil(maxValue * 1.2);
    }
    private renderInterpretationModePieChart() {
        this.$nextTick(() => {
            const chartData = this.getInterpretationModeChartData();
            const hasData = chartData.datasets.some((dataset) => dataset.data.some((value) => value > 0));

            const ctx = (this.$refs.modeOfInterpretationPieChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.InterpretationModePieChartInstance) {
                this.InterpretationModePieChartInstance.destroy();
            }
            if (!hasData) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = '14px Arial';
                ctx.fillStyle = '#999';
                ctx.textAlign = 'center';
                ctx.fillText('', ctx.canvas.width / 2, ctx.canvas.height / 2);
                return;
            }
            this.InterpretationModePieChartInstance = new Chart(ctx, {
                type: 'pie',
                data: this.getInterpretationModeChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                        onClick: (e) => {
                            e.stopPropagation();
                        },
                    },
                },
            });
            this.generateCustomLegendInterpretationMode();
        });
    }

    private generateCustomLegendInterpretationMode() {
        this.generateCustomLegend(
            this.$refs.customLegendModeOfInterpretation as HTMLElement,
            this.InterpretationModePieChartInstance,
            ['In-Person', 'Video', 'Phone'],
            ['#263FA9', '#26859e', '#39A896', '#50d0a8'],
            ['', '', ''],
            'legend-item-interpretationMode',
        );
    }

    private renderTrnasportationRequestTimingShedulePieChart() {
        this.$nextTick(() => {
            const chartData = this.getTransportationRequestTimingScheduleChartData();
            const hasData = chartData.datasets.some((dataset) => dataset.data.some((value) => value > 0));

            const ctx = (this.$refs.requestTimongShedulePieChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.TrnasportationRequestTimingShedulePieChartInstance) {
                this.TrnasportationRequestTimingShedulePieChartInstance.destroy();
                this.TrnasportationRequestTimingShedulePieChartInstance = null;
            }
            if (!hasData) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = '14px Arial';
                ctx.fillStyle = '#999';
                ctx.textAlign = 'center';
                ctx.fillText('', ctx.canvas.width / 2, ctx.canvas.height / 2);
                return;
            }
            this.TrnasportationRequestTimingShedulePieChartInstance = new Chart(ctx, {
                type: 'pie',
                data: this.getTransportationRequestTimingScheduleChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        // padding: 10,
                    },
                    legend: {
                        display: false,
                    },
                },
            });
            this.generateCustomLegendTimingSchedule();
        });
    }
    private generateCustomLegendTimingSchedule() {
        this.generateCustomLegend(
            this.$refs.customLegendSamePre as HTMLElement,
            this.TrnasportationRequestTimingShedulePieChartInstance,
            ['Same-Day', 'Pre-Scheduled'],
            ['#263FA9', '#16989D'],
            [
                'Submitted less than or equal to 24 hours before the pick-up time',
                'Submitted more than 24 hours before the pick-up time',
            ],
            'legend-item',
        );
    }

    private renderTrnasportationRequestTimingASAPPieChart() {
        this.$nextTick(() => {
            const chartData = this.getTransportationRequestTimingASAPChartData();
            const hasData = chartData.datasets.some((dataset) => dataset.data.some((value) => value > 0));

            const ctx = (this.$refs.requestTimongASAPPieChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.TrnasportationRequestTimingASAPPieChartInstance) {
                this.TrnasportationRequestTimingASAPPieChartInstance.destroy();
                this.TrnasportationRequestTimingASAPPieChartInstance = null;
            }
            if (!hasData) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = '14px Arial';
                ctx.fillStyle = '#999';
                ctx.textAlign = 'center';
                ctx.fillText('', ctx.canvas.width / 2, ctx.canvas.height / 2);
                return;
            }
            this.TrnasportationRequestTimingASAPPieChartInstance = new Chart(ctx, {
                type: 'pie',
                data: this.getTransportationRequestTimingASAPChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        // padding: 10,
                    },
                    legend: {
                        display: false,
                        position: 'right',
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                    },
                },

            });
            this.generateCustomLegendASAP();
        });
    }
    private generateCustomLegendASAP() {
        this.generateCustomLegend(
            this.$refs.customLegendASAP as HTMLElement,
            this.TrnasportationRequestTimingASAPPieChartInstance,
            ['ASAP', 'Non-ASAP'],
            ['#263FA9', '#16989D'],
            ['Sedan request submitted within the hour of pick-up time', ''],
            'legend-item-ASAP',
        );
    }

    private renderTrnasportationTripTypeRoundOrOneWayPieChart() {
        this.$nextTick(() => {
            const chartData = this.getTransportationTripTypeRoundOrOneWayChartData();
            const hasData = chartData.datasets.some((dataset) => dataset.data.some((value) => value > 0));

            const ctx = (this.$refs.tripTypeRoundOrOneWayPieChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.TrnasportationTripTypeRoundOrOneWayPieChartInstance) {
                this.TrnasportationTripTypeRoundOrOneWayPieChartInstance.destroy();
            }
            if (!hasData) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = '14px Arial';
                ctx.fillStyle = '#999';
                ctx.textAlign = 'center';
                ctx.fillText('', ctx.canvas.width / 2, ctx.canvas.height / 2);
                return;
            }
            this.TrnasportationTripTypeRoundOrOneWayPieChartInstance = new Chart(ctx, {
                type: 'pie',
                data: this.getTransportationTripTypeRoundOrOneWayChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        // padding: 10,
                    },
                    legend: {
                        display: false,
                        position: 'right',
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                    },
                },
            });
            this.generateCustomLegendRoundOrOneWay();
        });
    }
    private generateCustomLegendRoundOrOneWay() {
        this.generateCustomLegend(
            this.$refs.RoundOrOneWay as HTMLElement,
            this.TrnasportationTripTypeRoundOrOneWayPieChartInstance,
            ['Round Trip', 'One-Way Trip'],
            ['#263FA9', '#16989D'],
            ['', ''],
            'legend-item-ASAP',
        );
    }

    private renderTrnasportationPickAndAppointmentPieChart() {
        this.$nextTick(() => {
            const chartData = this.getTransportationTripTypePickOrAppointmentChartData();
            const hasData = chartData.datasets.some((dataset) => dataset.data.some((value) => value > 0));

            const ctx = (this.$refs.tripTypePickAndAppointmentPieChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.TrnasportationPickAndAppointmentPieChartInstance) {
                this.TrnasportationPickAndAppointmentPieChartInstance.destroy();
            }
            if (!hasData) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = '14px Arial';
                ctx.fillStyle = '#999';
                ctx.textAlign = 'center';
                ctx.fillText('', ctx.canvas.width / 2, ctx.canvas.height / 2);
                return;
            }
            this.TrnasportationPickAndAppointmentPieChartInstance = new Chart(ctx, {
                type: 'pie',
                data: this.getTransportationTripTypePickOrAppointmentChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        // padding: 10,
                    },
                    legend: {
                        display: false,
                        position: 'right',
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                    },
                },
            });
            this.generateCustomLegendPickAndAppointment();
        });
    }
    private generateCustomLegendPickAndAppointment() {
        this.generateCustomLegend(
            this.$refs.PickAndAppointment as HTMLElement,
            this.TrnasportationPickAndAppointmentPieChartInstance,
            ['Pick-Up Time', 'Appointment Time'],
            ['#263FA9', '#16989D'],
            [
                'One-Way Trips where patient is to be picked up at given time',
                'One-Way Trips where patient must arrive to appointment at given time',
            ],
            'legend-item-PickAndAppointment',
        );
    }

    private renderInterpretationRequestTimingShedulePieChart() {
        this.$nextTick(() => {
            const chartData = this.getInterpretationRequestTimingScheduleChartData();
            const hasData = chartData.datasets.some((dataset) => dataset.data.some((value) => value > 0));

            const ctx = (this.$refs.interpretationRequestTimongShedulePieChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.InterpretationRequestTimingShedulePieChartInstance) {
                this.InterpretationRequestTimingShedulePieChartInstance.destroy();
            }
            if (!hasData) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = '14px Arial';
                ctx.fillStyle = '#999';
                ctx.textAlign = 'center';
                ctx.fillText('', ctx.canvas.width / 2, ctx.canvas.height / 2);
                return;
            }
            this.InterpretationRequestTimingShedulePieChartInstance = new Chart(ctx, {
                type: 'pie',
                data: this.getInterpretationRequestTimingScheduleChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        // padding: 10,
                    },
                    legend: {
                        display: false,
                        position: 'right',
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                    },
                },
            });
            this.generateCustomLegendSchedule();
        });
    }

    private generateCustomLegendSchedule() {
        this.generateCustomLegend(
            this.$refs.customLegendShedule as HTMLElement,
            this.InterpretationRequestTimingShedulePieChartInstance,
            ['Same-Day', 'Pre-Scheduled'],
            ['#263FA9', '#16989D'],
            [
                'Submitted less than or equal to 24 hours appointment time',
                'Submitted more than 24 hours before appointment time',
            ],
            'legend-item-schedule',
        );
    }

    private renderInterpretationRequestTimingASAPPieChart() {
        this.$nextTick(() => {
            const chartData = this.getInterpretationRequestTimingASAPChartData();
            const hasData = chartData.datasets.some((dataset) => dataset.data.some((value) => value > 0));

            const ctx = (this.$refs.interpretationrRequestTimongASAPPieChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.InterpretationRequestTimingASAPPieChartInstance) {
                this.InterpretationRequestTimingASAPPieChartInstance.destroy();
            }
            if (!hasData) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = '14px Arial';
                ctx.fillStyle = '#999';
                ctx.textAlign = 'center';
                ctx.fillText('', ctx.canvas.width / 2, ctx.canvas.height / 2);
                return;
            }
            this.InterpretationRequestTimingASAPPieChartInstance = new Chart(ctx, {
                type: 'pie',
                data: this.getInterpretationRequestTimingASAPChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        // padding: 10,
                    },
                    legend: {
                        display: false,
                        position: 'right',
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                    },
                },
            });
            this.generateCustomLegendImmediate();
        });
    }

    private generateCustomLegendImmediate() {
        this.generateCustomLegend(
            this.$refs.customLegendImmediate as HTMLElement,
            this.InterpretationRequestTimingASAPPieChartInstance,
            ['Immediate', 'Non-Immediate'],
            ['#263FA9', '#16989D'],
            ['Service needed as soon as an interpreter is available', ''],
            'legend-item-immediate',
        );
    }

    private renderInterpretationLanguagesBarChart() {
        this.$nextTick(() => {
            const ctx = (this.$refs.interpretationLanguagesBarChart as HTMLCanvasElement).getContext('2d');
            if (!ctx) {
                return;
            }
            if (this.InterpretationLanguagesBarChartInstance) {
                this.InterpretationLanguagesBarChartInstance.destroy();
            }
            this.InterpretationLanguagesBarChartInstance = new Chart(ctx, {
                type: 'horizontalBar',
                data: this.getInterpretationLanguagesChartData(),
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            stacked: true,
                            gridLines: {
                                display: false,
                                drawBorder: false,
                            },
                            ticks: {
                                beginAtZero: true,
                                precision: 0,
                                stepSize: 1,
                                suggestedMax: this.calculateSuggestedMaxLanguage(),
                                callback: (value) => {
                                    return Number.isInteger(value) ? value : null;
                                },
                            },
                        }],
                        yAxes: [{
                            stacked: true,
                            // ticks: {
                            //     callback: function(value) {
                            //         const val = `${value}`;
                            //         return val.split(' ');
                            //     }
                            // }
                        }],
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: false,
                            boxWidth: 12,
                            padding: 15,
                            fontSize: 12,
                        },
                        onClick: (e) => {
                            e.stopPropagation();
                        },
                    },
                    animation: {
                        onComplete() {
                            const chartInstance = this as any;
                            const ctxx = chartInstance.chart.ctx;
                            ctxx.textAlign = 'left';
                            ctxx.textBaseline = 'middle';
                            ctxx.fillStyle = '#000';

                            chartInstance.data.datasets.forEach((dataset: any, i: number) => {
                                const meta = chartInstance.getDatasetMeta(i);
                                meta.data.forEach((bar: any, index: number) => {
                                    const data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x + 10, bar._model.y);
                                });
                            });
                        },
                    },
                },
            });
        });
    }
    private calculateSuggestedMaxLanguage(): number {
        const maxValue = Math.max(...this.getInterpretationLanguagesChartData().datasets[0].data);
        return maxValue < 10 ? maxValue + 2 : Math.ceil(maxValue * 1.2);
    }

    private async getReportData() {
        const iHttpService = ObjectFactory.getHttpService();
        const getRequestStatistics: GetRequestStatistics = {};
        if (this.startDate && this.endDate) {
            getRequestStatistics.dateRange = {
                startTime: DateUtils.convertToUTCInMillis(this.startDate),
                endTime: DateUtils.convertToUTCInMillis(this.endDate),
            };
        }
        if (this.selectedBillingLocations && this.selectedBillingLocations.length > 0) {
            const isAllSelected = this.selectedBillingLocations.some((location: OrgLocation) => location.id === 'All');
            if (!isAllSelected) {
                getRequestStatistics.locationNames = [];
                this.selectedBillingLocations.forEach((location: OrgLocation) => {
                    if (getRequestStatistics.locationNames && location.locationName) {
                        getRequestStatistics.locationNames.push(location.locationName);
                    }
                });
            }
        } else {
            if (this.orgLocations && this.orgLocations.length > 0) {
                getRequestStatistics.locationNames = [];
                this.orgLocations.forEach((location) => {
                    if (location.locationName && getRequestStatistics.locationNames) {
                        getRequestStatistics.locationNames.push(location.locationName);
                    }
                });
            }
        }
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: getRequestStatistics,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/statistics`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<CustomerDashboardResponse>(apiRequest);
        if (response.success && response.data) {
            this.reportData = response.data;
            this.renderDashboardChartData();
        }
    }

    private async getOrganizationLocations() {
        const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        const allOption: OrgLocation = {
            id: 'All',
            locationName: 'All Locations',
        };
        const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
        if (response.success && response.data) {
            if ((memberProfile.memberType === 'ORG_MANAGER' || memberProfile.memberType === 'ORG_MEMBER')
                && memberProfile.managedLocations && memberProfile.managedLocations.length > 0) {
                const managedLocations = memberProfile.managedLocations || [];
                response.data = response.data.filter((a) =>
                    managedLocations.some((b) => b.id === a.id),
                );
            } else {
                response.data.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
            }
            this.orgLocations = [allOption, ...response.data];
        } else {
            CommonUtils.showError(response);
        }
    }

}
